/**
 * Which panel of the settings screen a link is asking for.
 *
 * Shared because the screen reads this parameter out of the query string and
 * three other screens write it in. A link that spells it differently does not
 * fail — `readTab` falls back to the default panel — so the reader simply
 * lands on the language settings having asked for Backlog, which is the bug
 * this exists to make impossible.
 */
export const SETTINGS_TAB_PARAM = 'tab'

/**
 * Where a "connect Backlog" link goes.
 *
 * Every one of them means the same thing and none of them means the settings
 * screen in general: the reader pressed a sentence about Backlog, and the
 * panel holding the Connect button is the only answer to it.
 */
export const SETTINGS_BACKLOG_PATH = `/settings?${SETTINGS_TAB_PARAM}=backlog`
